import React from "react";

import type { JSX, ReactNode } from "react";

interface LoginTitleProps {
  children: ReactNode;
}

function LoginTitle({ children }: LoginTitleProps): JSX.Element {
  return (
    <h1 className="text-foreground text-center text-base font-semibold">
      {children}
    </h1>
  );
}

export default LoginTitle;
